import { Link } from "react-router-dom";
import { useEffect } from "react";
import { useAdminAuth } from "../../context/AdminAuthContext";
import { ADMIN_HOME_HERO_PHOTOS_PATH, ADMIN_LATEST_PHOTOS_PATH, ADMIN_NEWSLETTER_SUBSCRIBERS_PATH, ADMIN_VIDEOS_PATH, ADMIN_ABOUT_SELFIES_PATH } from "../../lib/adminPaths";

export default function AdminDashboardPage() {
  const { user, logout } = useAdminAuth();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="admin-page">
      <header className="admin-header">
        <div>
          <p className="admin-eyebrow">ADMIN</p>
          <h1 className="admin-title admin-title--compact">Dashboard</h1>
        </div>
        <button className="admin-button admin-button--ghost" type="button" onClick={() => void logout()}>
          Sign out
        </button>
      </header>

      <section className="admin-card">
        <p className="admin-lede">
          Signed in as <strong>{user?.username}</strong>.
        </p>
        <p className="admin-muted">Choose a section below to manage site content.</p>
      </section>

      <div className="admin-card-grid">
        <Link className="admin-tool-card" to={ADMIN_HOME_HERO_PHOTOS_PATH}>
          <p className="admin-eyebrow">Home page</p>
          <h2 className="admin-tool-card__title">Home Page Photo Show</h2>
          <p className="admin-muted">
            Upload hero carousel photos — they also appear as signature frames on the photography page.
          </p>
          <span className="admin-tool-card__cta">Open →</span>
        </Link>
        <Link className="admin-tool-card" to={ADMIN_LATEST_PHOTOS_PATH}>
          <p className="admin-eyebrow">Home page</p>
          <h2 className="admin-tool-card__title">Latest Photographs</h2>
          <p className="admin-muted">
            Choose the five photos shown in the Latest Photographs section.
          </p>
          <span className="admin-tool-card__cta">Open →</span>
        </Link>
        <Link className="admin-tool-card" to={ADMIN_VIDEOS_PATH}>
          <p className="admin-eyebrow">Video</p>
          <h2 className="admin-tool-card__title">YouTube Videos</h2>
          <p className="admin-muted">
            Add videos from your YouTube channel and pick two for the home page.
          </p>
          <span className="admin-tool-card__cta">Open →</span>
        </Link>
        <Link className="admin-tool-card" to={ADMIN_ABOUT_SELFIES_PATH}>
          <p className="admin-eyebrow">About page</p>
          <h2 className="admin-tool-card__title">Selfies over the years</h2>
          <p className="admin-muted">
            Upload and reorder the selfie collage on the About page.
          </p>
          <span className="admin-tool-card__cta">Open →</span>
        </Link>
        <Link className="admin-tool-card" to={ADMIN_NEWSLETTER_SUBSCRIBERS_PATH}>
          <p className="admin-eyebrow">Audience</p>
          <h2 className="admin-tool-card__title">Stay in Touch</h2>
          <p className="admin-muted">
            See who signed up from the footer newsletter form — names and email addresses.
          </p>
          <span className="admin-tool-card__cta">Open →</span>
        </Link>
      </div>
    </div>
  );
}
